import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import pluralize from 'pluralize';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { ORGANIZATION_USERS_QUERY_KEY } from 'hooks/queries/organization';

export const useRemoveUsersFromOrganizationMutation = (
  onSuccess?: () => void
): UseMutationResult<
  AxiosResponse<unknown>,
  unknown,
  { orgId: string; users: string[] }
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ orgId, users }) => {
      return apiClient.user.bulkDeleteOrganizationUsers({
        organizationId: orgId,
        users,
      });
    },
    onSuccess: async (_, { users }) => {
      await queryClient.invalidateQueries({
        queryKey: [ORGANIZATION_USERS_QUERY_KEY],
      });
      notify.success(
        `${pluralize('User', users.length, true)} removed from organization`
      );
      onSuccess?.();
    },
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
  });
};
